if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        this.cancelProductRequest();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        drawerContent.setAttribute('aria-busy', 'false');
        this.classList.remove(this._classes.loaded);
      }

      hide() {
        this.cancelProductRequest();
        return super.hide();
      }

      cancelProductRequest() {
        this.productRequestId = (this.productRequestId || 0) + 1;
        this.productRequestController?.abort();
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        this.cancelProductRequest();
        const requestId = this.productRequestId;
        const controller = new AbortController();
        this.productRequestController = controller;
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        const sectionUrl = new URL(this.dataset.productUrl, window.location.origin);
        sectionUrl.searchParams.set('section_id', sectionId);
        drawerContent.replaceChildren();
        drawerContent.setAttribute('aria-busy', 'true');
        this.classList.remove(this._classes.loaded);
        fetch(sectionUrl.toString(), { signal: controller.signal, credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Product section unavailable');
            return response.text();
          })
          .then((responseText) => {
            if (requestId !== this.productRequestId || !this.open || !this.isConnected) return;
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);
            if (!productElement?.content) throw new Error('Product section not found');

            this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              try {
                Shopify.PaymentButton.init();
              } catch (error) {
                console.warn('Shopify accelerated checkout could not initialize.', error);
              }
            }

            this.classList.add(this._classes.loaded);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            if (requestId !== this.productRequestId || !this.open || !this.isConnected) return;
            const panel = document.createElement('div');
            panel.className = 'snkr-quick-buy__error';
            const message = document.createElement('p');
            message.setAttribute('role', 'alert');
            message.textContent = 'Le produit n’a pas pu être chargé. Réessayez ou ouvrez sa fiche.';
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.className = 'btn btn--primary';
            retry.textContent = 'Réessayer';
            retry.addEventListener('click', () => this.quickview(), { once: true });
            const link = document.createElement('a');
            link.href = this.dataset.productUrl;
            link.textContent = 'Voir la fiche produit';
            panel.append(message, retry, link);
            drawerContent.replaceChildren(panel);
            this.classList.add(this._classes.loaded);
            FoxTheme.a11y.trapFocus(this, this.focusElement);
          })
          .finally(() => {
            window.clearTimeout(timeout);
            if (requestId === this.productRequestId) drawerContent.setAttribute('aria-busy', 'false');
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        // The native drawer moves itself into <body> when opening. That move
        // must not clear the new product, abort its request or release its lock.
        if (!this.isConnected) {
          this.cancelProductRequest();
          this.querySelector(this.selector).replaceChildren();
        }
      }
    }
  );
}
